import * as types from './constants';

// `global` = platform-wide (brand-safe) signals, `brand` = this brand's signals for the creator.
// Either is null when the API doesn't expose it (creator not unmasked for the brand); both are
// null on 404, which means the creator is outside the signals population.
const initialState = {
  data: { global: null, brand: null },
  loaded: false,
  loading: false,
  errors_api: {},
  errorStatus: null
};

const actions = {
  // Get Creator Signals
  [types.GET_CREATOR_SIGNALS_REQUEST]: state => ({
    ...state,
    loading: true,
    errors_api: {},
    errorStatus: null
  }),

  [types.GET_CREATOR_SIGNALS_DONE]: (state, { payload }) => ({
    ...state,
    data: payload,
    loaded: true,
    loading: false,
    errors_api: {},
    errorStatus: null
  }),

  [types.GET_CREATOR_SIGNALS_FAILED]: (state, { payload }) => ({
    ...state,
    data: initialState.data,
    loaded: true,
    loading: false,
    errors_api: payload?.errors_api || {},
    errorStatus: payload?.status || null
  }),

  [types.GET_CREATOR_SIGNALS_RESET]: () => ({ ...initialState })
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
